<template>
  <button
    v-if="isVisible && session.route.sublocationToken"
    type="button"
    class="cf-button cf-button--secondary cf-button--lg"
    :class="{ 'cf-button--loading': isProcessing }"
    @click="resetTable"
  >
    Reset Table
  </button>
</template>


<script>
  /*
    NOTE:
    This button is used for a hacky P@T test environment flow.
    There are no unit tests for this component.
  */

  import { mapGetters } from 'vuex';

  import http from '@/services/http';
  import logger from '@/services/logger';

  import returnAppConfig from '@/helpers/return-app-config';


  export default {
    name: 'ResetTableButton',

    data() {
      return {
        isProcessing: false,
        isVisible: false
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['session'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        const { isTestEnvironment } = returnAppConfig();
        const isPayAtTable = this.$route.fullPath.indexOf('/pay-at-table/') > -1;
        const isOrderAtTable = !!this.session.route.tableNumber;

        this.isVisible = isTestEnvironment && isPayAtTable && !isOrderAtTable && !this.merchant.options.disableReset;
      },

      async resetTable() {
        try {
          this.isProcessing = true;

          await http.get(`/cardfree-api/v1/pat/merchant/${this.merchant.id}/reset/${this.session.route.sublocationToken}`);

          document.location.replace(`/${this.session.route.merchantId}/welcome?sublocationToken=${this.session.route.sublocationToken}`);
        }

        catch (error) {
          logger.error(error);

          this.isProcessing = false;
        }
      }
    }
  };
</script>
